import React from 'react'
import { useSelector } from "react-redux";
import * as constants from "./constants";
export const GetCallProgess = () => {
  const hold_status = useSelector((state) => {
    return state.ticker[constants.CALL_COMMANDS.HOLD];
  });

  return (
    <>{hold_status === constants.HOLD_STATES.ON_HOLD ? "ON HOLD" : "ONGOING"}</>
  );
};
